import React from 'react';
import { createRoot } from 'react-dom/client';
import DownloadsBlock from './App';

const elementContainer = document.querySelector<HTMLElement>('#portal-downloads-block');

if (elementContainer) {
  const heading = elementContainer.dataset.heading;
  const expiryNotificationText = elementContainer.dataset.expiryText;
  const expiryDateLabel = elementContainer.dataset.expiryDateLabel;

  const root = createRoot(elementContainer);
  root.render(
    <DownloadsBlock
      heading={heading}
      expiryNotificationText={expiryNotificationText}
      expiryDateLabel={expiryDateLabel}
    />
  );
}
